/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Time_SlotInputs */



/**
* | output |
* | --- |
* | "Edit time slot" |
*
* @param {Edit_Time_SlotInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const edit_time_slot = /** @type {((inputs?: Edit_Time_SlotInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Time_SlotInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Edit time slot")
	return /** @type {LocalizedString} */ ("Modifier la plage horaire")
});